import { getTranslationKey } from '../../modules/utils/helpers';
import { CommentsMode } from '../../modules/types/comments';

export const disableCommentsModes: { [key: string]: CommentsMode } = {
  hide: 'hidden',
  delete: 'deleted',
  readOnly: 'readOnly'
};

export const getListData = (): { name: CommentsMode; label: string }[] => [
  {
    name: disableCommentsModes.hide,
    label: getTranslationKey('collectionSettings.disableComments.hideOption')
  },
  {
    name: disableCommentsModes.delete,
    label: getTranslationKey('collectionSettings.disableComments.deleteOption')
  },
  {
    name: disableCommentsModes.readOnly,
    label: getTranslationKey('collectionSettings.disableComments.readOnlyOption')
  }
];
